import Demo from './demo.svelte';

new Demo({
  target: document.getElementById('demo'),
  props: {}
});
